var map = {
	"./ERUPT_2017_pic.jpg": 182,
	"./ERUPT_2019_pic.jpeg": 183,
	"./HEAT_2019_pic.jpg": 181,
	"./SWIFT_2019_pic.jpeg": 184,
	"./WFDF_hand_signals.jpeg": 382,
	"./alex_west_map.jpeg": 383,
	"./alex_west_map_3_fields_left.png": 384,
	"./fdi_logo.png": 185,
	"./sodic_map.jpeg": 385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;